import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { updateAdsConsent } from "@/lib/gtag";
import { persistTouches } from "@/lib/api";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("ec_cookie_consent")) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (choice) => {
    localStorage.setItem("ec_cookie_consent", choice);
    updateAdsConsent(choice === "accepted");
    persistTouches();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-consent" className="fixed bottom-4 inset-x-4 md:left-auto md:right-6 md:max-w-md z-[60] bg-emerald-950 text-emerald-50 rounded-xl shadow-2xl p-5 border border-brass/30 animate-fade-up">
      <p className="text-sm leading-relaxed text-emerald-100/90">
        We use essential cookies to run this site and optional analytics cookies to understand how it is used.
        See our <Link to="/privacy-policy" className="underline text-brass">Privacy Notice</Link>.
      </p>
      <div className="flex gap-2 mt-4">
        <Button data-testid="cookie-accept" onClick={() => decide("accepted")} className="flex-1 bg-brass hover:bg-brass-600 text-emerald-950 rounded-full text-sm h-9">Accept all</Button>
        <Button data-testid="cookie-reject" onClick={() => decide("essential")} variant="outline" className="flex-1 border-emerald-100/30 text-emerald-50 hover:bg-white/10 bg-transparent rounded-full text-sm h-9">Essential only</Button>
      </div>
    </div>
  );
};
